<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>CẬP NHẬT BIÊN BẢN THI</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 py-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-radio-group v-model="status" label="Trạng thái" row>
            <v-radio
              v-for="option in statusOptions"
              :key="option.value"
              :label="option.name"
              :value="option.value"
            ></v-radio>
          </v-radio-group>
          <v-textarea label="Ghi chú" v-model="note" outlined hide-details></v-textarea>
        </v-form>
      </v-card-text>
      <v-divider> </v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    state: Boolean,
    data: Object
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    data: {
      immediate: true,
      handler(newData) {
        if (newData) {
          this.setFormValues(newData)
        }
      }
    }
  },
  computed: {},
  data() {
    return {
      dialog: false,
      loading: false,
      status: '',
      note: '',
      statusOptions: [
        { name: 'Có thi', value: 'present' },
        { name: 'Vắng thi', value: 'absent' },
        { name: 'VPQC', value: 'suspended' }
      ]
    }
  },
  methods: {
    ...mapActions('examMark', ['updateMark']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        const roomData = {
          status: this.status,
          note: this.note
        }
        const updatedRoom = await this.updateMark({ id: this.data.id, ...roomData })
        if (updatedRoom) {
          this.$emit('refresh')
          this.close()
        }
      }
    },

    setFormValues(data) {
      this.status = data.status || ''
      this.note = data.note || ''
    }
  }
}
</script>
